import React from 'react';
import type { PackInfo } from '../hooks/useFortiFlexData';

interface PackInfoStripProps {
    packs: PackInfo[];
    activeEntitlements: number;
    uniqueAccounts: number;
}

const PackInfoStrip: React.FC<PackInfoStripProps> = ({
    packs,
    activeEntitlements,
    uniqueAccounts,
}) => {
    if (!packs.length) return null;

    return (
        <div className="flex flex-wrap gap-6 rounded-sm border border-semantic-border-primary bg-semantic-bg-secondary-subtle px-4 py-3 mb-4 text-sm">
            {packs.map((p) => (
                <React.Fragment key={p.packNumber}>
                    <div>
                        <span className="font-medium text-semantic-text-secondary text-xs uppercase tracking-wider">
                            Pack #{p.packIndex}
                        </span>
                        <span className="ml-2 text-semantic-text-primary font-medium">
                            {p.packNumber}
                        </span>
                    </div>
                    <div>
                        <span className="text-semantic-text-secondary text-xs uppercase tracking-wider">
                            Start
                        </span>
                        <span className="ml-2 text-semantic-text-primary">{p.startDate}</span>
                    </div>
                    <div>
                        <span className="text-semantic-text-secondary text-xs uppercase tracking-wider">
                            Expiration
                        </span>
                        <span className="ml-2 text-semantic-text-primary">{p.expirationDate}</span>
                    </div>
                </React.Fragment>
            ))}
            <div>
                <span className="text-semantic-text-secondary text-xs uppercase tracking-wider">
                    Active Entitlements
                </span>
                <span className="ml-2 font-medium text-semantic-text-brand">{activeEntitlements}</span>
            </div>
            <div>
                <span className="text-semantic-text-secondary text-xs uppercase tracking-wider">
                    Accounts
                </span>
                <span className="ml-2 font-medium text-semantic-text-brand">{uniqueAccounts}</span>
            </div>
        </div>
    );
};

export default PackInfoStrip;
